function veda_fn_3b285d9ca2b6436cbdb16d82915e22cf () {
      
  if (window.veda_fn_3b285d9ca2b6436cbdb16d82915e22cfCleanup === undefined) {
    window.veda_fn_3b285d9ca2b6436cbdb16d82915e22cfCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_3b285d9ca2b6436cbdb16d82915e22cfCleanup.cleanup();

      try {
        const uniqueId = "id_39114f7a-3f26-4a0d-8c2a-3f15fa5c6929";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const loginForm = container.querySelector(".login-form-js");
const recoverForm = container.querySelector(".recover-form-js");
const btnRecover = container.querySelector(".btn-recover-password-js");
const btnCancel = container.querySelector(".btn-recover-password-cancel-js");
const btnLoginToRecover = container.querySelector(".btn-login-to-recover-js");

function visibleLogin() {
  loginForm.style.display = "block";
  recoverForm.style.display = "none";
}

function visibleRecover() {
  loginForm.style.display = "none";
  recoverForm.style.display = "block";
}

function loadVisibleForm() {
  if (!builderMode && location.hash === "#recover") {
    visibleRecover();
  } else {
    visibleLogin();
  }
}

btnRecover.addEventListener("click", visibleLogin);
btnCancel.addEventListener("click", visibleLogin);
btnLoginToRecover.addEventListener("click", visibleRecover);
window.addEventListener("load", loadVisibleForm);
window.veda_fn_3b285d9ca2b6436cbdb16d82915e22cfCleanup.push(() => {
  btnRecover.removeEventListener("click", visibleLogin);
  btnCancel.removeEventListener("click", visibleLogin);
  btnLoginToRecover.removeEventListener("click", visibleRecover);
  window.removeEventListener("load", loadVisibleForm);
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_3b285d9ca2b6436cbdb16d82915e22cf();